<script lang="ts">
	import '../DstAboNavigation/DstAboNavigation.webcomponent.svelte';
	import '../DstAboServiceNavigation/DstAboServiceNavigation.webcomponent.svelte';
	import '../DstAboutNavigation/DstAboutNavigation.webcomponent.svelte';
	import '../DstEditorialDeNavigation/DstEditorialDeNavigation.webcomponent.svelte';
	import '../DstEditorialAtNavigation/DstEditorialAtNavigation.webcomponent.svelte';
	import { headerTypes } from '@/config.ts';

	export let gestalt: string;
	export let compact: boolean;
</script>

{#if gestalt === 'abo_default'}
	<dst-abo-navigation class="no-touch" class:compact={compact}>
		<div slot="breadcrumb">
			<slot name="breadcrumb" />
		</div>
	</dst-abo-navigation>
{:else if gestalt === 'abo_service'}
	<dst-aboservice-navigation class="no-touch" class:compact={compact}>
		<div slot="breadcrumb">
			<slot name="breadcrumb" />
		</div>
	</dst-aboservice-navigation>
{:else if gestalt === 'about_default'}
	<dst-about-navigation class="no-touch" class:compact={compact}>
		<div slot="breadcrumb">
			<slot name="breadcrumb" />
		</div>
	</dst-about-navigation>
{:else if headerTypes.editorialDe.includes(gestalt)}
	<dst-de-navigation class="no-touch" class:compact={compact}>
		<div slot="breadcrumb">
			<slot name="breadcrumb" />
		</div>
	</dst-de-navigation>
{:else if headerTypes.editorialAt.includes(gestalt)}
	<dst-at-navigation class="no-touch" class:compact={compact}>
		<div slot="breadcrumb">
			<slot name="breadcrumb" />
		</div>
	</dst-at-navigation>
{/if}
